<nz-radio-group
  [nzSize]="$any(size)"
  [(ngModel)]="value"
  (ngModelChange)="valueChange.emit($event)"
  [nzButtonStyle]="'solid'"
>
  <label nz-radio-button [nzValue]="opt.value" *ngFor="let opt of options">
    {{ opt.label }}
  </label>
</nz-radio-group>
